export interface ClaimItem {
  claimFormId: string
  notifyNumber: string
  claimNumber: string
  policyNumber: string
  notifyAt: Date
  policyGroup: string
  treatmentType: string
  claimStatus: string
  claimStatusCode: string
  insuredName: string
  mobilePhone: string
  identityId: string
  hospitalName: string
  treatmentDateIn: string
  treatmentDateOut: string
  treatmentAmount: number
  receiptNumber: string
  approvedClaimAmount: number
  diseasesName: string
  accidentLocation: string
  accidentDate: Date | null
  accidentTime: string | null
  accidentDetails: string | null
  reimbursementMethod: string
  bankName: string | null
  bankBranch: string | null
  bankAccountNumber: string | null
  bankAccountName: string | null
  postAddress: string | null
  claimChannel: string
  autoAssignUserId: string | null
  autoAssignUserName: string | null
  ownerId: string | null
  ownerName: string | null
  approveAt: Date | null
  approvedBy: string | null
  lastUpdatedAt: Date
  remark: string | null
  hasRejectDocument: boolean
}

export interface ClaimListMeta {
  itemsPerPage: number
  totalItems: number
  currentPage: number
  totalPages: number
  sortBy: Array<[string, 'ASC' | 'DESC']>
  searchBy: string[]
  search: string
  select: string[]
  filter: {
    'currentClaimStatus.code': string
  }
}

export interface ClaimListLinks {
  first: string
  previous: string
  current: string
  next: string
  last: string
}

export interface ClaimListResponse {
  data: ClaimItem[]
  meta: ClaimListMeta
  links: ClaimListLinks
}

export interface FilterOptionResponse {
  display: string
  value: string
}

// Enums for health claim
export enum InterestTypeEnum {
  OLD = 'OLD',
  NEW = 'NEW',
}

// Interest Code interface for NEW type
export interface InterestCode {
  interestCode: string
  maxClaimAmount: number
  remainingClaimBalance: number
  receiptAmount?: number
  coverageAmount?: number
}

// Claim Type interface for OLD type
export interface ClaimType {
  id: string
  coverageAmount: number
}

// Document interface
export interface ClaimDocument {
  documentId: string
}

// Main Health Claim Form interface
export interface HealthClaimFormInput {
  claimFormId?: string
  previousClaimFormId?: string
  policyNumber: string
  email?: string
  mobileNumber: string
  treatmentTypeId: string
  treatmentDateIn: string // will be formatted as 'YYYY-MM-DD'
  treatmentDateOut?: string // will be formatted as 'YYYY-MM-DD'
  hospitalId?: string
  isOtherHospital?: boolean
  otherHospitalName?: string
  diseaseId?: string
  accidentLocation?: string
  accidentDate?: string // will be formatted as 'YYYY-MM-DD'
  accidentTime?: string // will be formatted as 'HH:mm'
  accidentDetails?: string
  treatmentAmount?: number
  receiptNumber: string
  approvedClaimAmount?: number
  interestType: InterestTypeEnum
  interestCodes?: InterestCode[]
  claimTypes?: ClaimType[]
  reimbursementMethod: string
  bankId?: string
  bankAccountNumber?: string
  bankAccountName?: string
  bankBranch?: string
  isUserPolicyAddress?: boolean
  compensationPersonName?: string
  compensationPersonPhone?: string
  compensationAddress?: string
  compensationProvinceCode?: string
  compensationDistrictCode?: string
  compensationSubDistrictCode?: string
  compensationPostCode?: string
  documents?: ClaimDocument[]
}
